import { Fragment, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@mui/material/Button";
import { Backdrop, Box, Paper } from "@mui/material";

import Carousel from "react-material-ui-carousel";
import { setBannersModalVisible } from "../../store/actions/banner-actions";

import {
  getWindowDimensions,
  isEmpty,
  preloadImage,
} from "../../library/utils";

export default function BannerModal() {
  const dispatch = useDispatch();

  const bannersList = useSelector((state) => state.banners.bannersList);
  const isBannersModalVisible = useSelector(
    (state) => state.banners.isBannersModalVisible
  );

  const [initialImageLoaded, setInitialImageLoaded] = useState(false);

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [carouselWidth, setCarouselWidth] = useState(1000);
  const [carouselHeight] = useState(windowDimensions.height);
  const [imageSize, setImageSize] = useState(windowDimensions);

  const handleClose = () => {
    localStorage.setItem("bannerShown", "true");

    dispatch(setBannersModalVisible(false));
  };

  const handleOpenLink = (url) => {
    window.open(url, "_blank");
  };

  const handleLoadCallback = useCallback(() => {
    setInitialImageLoaded(true);
  }, []);

  useEffect(() => {
    if (bannersList.length > 0) {
      const imgObject = bannersList[0];
      preloadImage(imgObject.urlImage, handleLoadCallback);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannersList]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    let finalWidth =
      windowDimensions.width > 800 ? 800 : windowDimensions.width * 0.9;
    if (finalWidth > windowDimensions.height) {
      finalWidth = windowDimensions.height * 0.9 - 100;
    }
    setCarouselWidth(finalWidth);
  }, [windowDimensions]);

  const handleImageLoad = (e) => {
    const { naturalHeight, naturalWidth } = e.target;
    setImageSize({
      height: naturalHeight,
      width: naturalWidth * (carouselWidth / naturalWidth),
    });
  };

  return (
    <Fragment>
      <Backdrop
        open={isBannersModalVisible}
        sx={{ zIndex: 1000 }}
        onClick={handleClose}
      >
        {initialImageLoaded && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              m: "100%",
            }}
          >
            {bannersList.length > 0 && (
              <Carousel
                sx={{
                  minWidth: carouselWidth,
                  width: "100%",
                  maxHeight: carouselHeight,
                }}
                interval={7000}
                animation={"slide"}
                navButtonsAlwaysVisible={bannersList.length > 1}
                navButtonsAlwaysInvisible={bannersList.length === 1}
              >
                {bannersList.map((item, i) => (
                  <Paper
                    key={i}
                    style={{
                      width: carouselWidth,
                      height: undefined,
                      display: "flex",
                      flexFlow: "column wrap",
                      alignItems: "center",
                      alignContent: "center",
                      backgroundColor: "transparent",
                      boxShadow: "none",
                    }}
                  >
                    {initialImageLoaded && (
                      <img
                        alt={item.title}
                        src={item.urlImage}
                        onLoad={handleImageLoad}
                        style={{
                          minWidth: carouselWidth,
                          maxWidth: imageSize.width,
                          maxHeight: carouselHeight - 100,
                          width: "auto",
                          height: "auto",
                        }}
                      />
                    )}
                    {!isEmpty(item.redirectUrl) && (
                      <Button
                        autoFocus
                        onClick={() => handleOpenLink(item.redirectUrl)}
                        sx={{ alignSelf: "center" }}
                      >
                        Visit Link
                      </Button>
                    )}
                  </Paper>
                ))}
              </Carousel>
            )}
            <Button
              autoFocus
              onClick={handleClose}
              sx={{ alignSelf: "center", paddingTop: 3 }}
            >
              Remind Later
            </Button>
          </Box>
        )}
      </Backdrop>
    </Fragment>
  );
}
